import { createTheme } from "@mui/material";

const TOOLTIP_Z_INDEX = 15000;

export const theme = createTheme({
  typography: {
    fontFamily: ["Public-Sans", "sans-serif"].join(","),
  },

  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: TOOLTIP_Z_INDEX,
  },

  components: {
    MuiTooltip: {
      defaultProps: {
        PopperProps: {
          sx: { zIndex: TOOLTIP_Z_INDEX },
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        // The default props to change
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          margin: "dense",
          shrink: true,
        },
      },
    },

    MuiButton: {
      defaultProps: {
        size: "small",
        variant: "contained",
      },

      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});
